<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="user-dates">
    <div class="has-side-bars">
      <div class="top-wrap">
        <h3>{{ $t('user_dates') }}</h3>
        <div v-if="!editMode" class="icon-edit" @click="toggleEditMode" />
        <div v-else class="edition-wrapper">
          <div class="close-wrapper" @click="toggleEditMode">
            <div class="icon-close" />
          </div>
          <div class="button-save" @click="saveEdit">
            <span>{{ $t('save') }}</span>
          </div>
        </div>
      </div>
      <div v-if="stringError !== ''" class="error-msg">
        <span>{{ stringError }}</span>
      </div>
      <div v-if="userData" class="info-wrapper">
        <table>
          <tr class="op-wrap">
            <td class="op-type">
              <span>{{ $t('reg_name') }}</span>
            </td>
            <td class="op-ans">
              <span v-if="!editMode">{{ userData.name }}</span>
              <input
                v-else
                v-model="nameInput"
                class="register-input"
                :class="arrayErrorInputs.indexOf('name') !== -1 && 'error'"
                type="text"
                :placeholder="userData.name"
              >
            </td>
          </tr>
          <tr class="op-wrap">
            <td class="op-type">
              <span>{{ $t('reg_sur') }}</span>
            </td>
            <td class="op-ans">
              <span v-if="!editMode">{{ userData.surname }}</span>
              <input
                v-else
                v-model="surnameInput"
                class="register-input"
                :class="arrayErrorInputs.indexOf('surname') !== -1 && 'error'"
                type="text"
                :placeholder="userData.surname"
              >
            </td>
          </tr>
          <tr class="op-wrap">
            <td class="op-type">
              <span>{{ $t('email_low') }}</span>
            </td>
            <td class="op-ans">
              <span v-if="!editMode">{{ userData.email }}</span>
              <input
                v-else
                v-model="emailInput"
                class="register-input"
                :class="arrayErrorInputs.indexOf('email') !== -1 && 'error'"
                type="text"
                :placeholder="userData.email"
              >
            </td>
          </tr>
          <tr class="op-wrap">
            <td class="op-type">
              <span>{{ $t('reg_lang') }}</span>
            </td>
            <td class="op-ans">
              <span v-if="!editMode">{{ $t('lang_' + userData.language) }}</span>
              <select v-else v-model="formLang" class="register-select">
                <option
                  v-for="o in languageOp"
                  :key="o"
                  :value="o"
                  :label="$t('lang_' + o)"
                />
              </select>
            </td>
          </tr>
          <tr class="op-wrap">
            <td class="op-type">
              <span>{{ $t('reg_sex') }}</span>
            </td>
            <td class="op-ans">
              <span v-if="!editMode">{{ $t('sex_' + userData.gender) }}</span>
              <select v-else v-model="formSex" class="register-select">
                <option value="NS" :label="$t('sel_placeholder')" />
                <option
                  v-for="o in sexOp"
                  :key="o"
                  :value="o"
                  :label="$t('sex_' + o)"
                />
              </select>
            </td>
          </tr>
          <tr class="op-wrap">
            <td class="op-type">
              <span>{{ $t('password') }}</span>
            </td>
            <td class="op-ans">
              <span v-if="!editMode">{{ formPass }}</span>
              <input
                v-else
                v-model="passInput"
                class="register-input"
                :class="arrayErrorInputs.indexOf('password') !== -1 && 'error'"
                type="password"
                :placeholder="formPass"
              >
            </td>
          </tr>
          <tr class="op-extend-wrap">
            <td class="op-type">
              <span>{{ $t('client_id') }}</span>
            </td>
            <td v-if="clientId" class="op-ans">
              <span>{{ clientId }}</span>
            </td>
            <td v-else-if="clientIdRequest" class="op-ans">
              <span class="state-pending">{{ $t('client_id_pending') }}</span>
            </td>
            <td v-else class="op-ans">
              <div class="button-drop-out not-margin" @click="requestClientId">
                <span>{{ $t('ask_client_id') }}</span>
              </div>
            </td>
          </tr>
          <tr v-if="editMode && passInput !== ''">
            <td colspan="2">
              <PasswordHelp :password-input="passInput" />
            </td>
          </tr>
          <tr class="op-extention-wrap">
            <td colspan="2">
              <span class="op-mod">{{ $t('last_mod') + formattedLastChange }}</span>
            </td>
          </tr>
        </table>
      </div>
      <div class="button-drop-out" @click="dropOutConfirm">
        <span>{{ $t('drop_out') }}</span>
      </div>
    </div>
    <modal
      name="modal-drop-out"
      :width="isMobile ? '90%' : '60%'"
      height="25%"
      :style="isMobile ? 'marginTop: 5%' : 'marginTop: 0'"
    >
      <ModalDropOut :modal-close="modalClose" />
    </modal>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import PasswordHelp from './PasswordHelp.vue'
import { getUserData, setUserData, requestClientID } from '@/services/user-api'
// import { t } from '@/i18n'
import ModalDropOut from '../modals/ModalDropOut.vue'

export default {
  components: { PasswordHelp, ModalDropOut },
  props: {},
  data() {
    return {
      editMode: false,
      formPass: '**********',
      formLang: 'NS',
      formSex: 'M',
      nameInput: '',
      surnameInput: '',
      emailInput: '',
      passInput: '',
      languageOp: ['ca', 'es', 'en'],
      sexOp: ['M', 'F'],
      arrayErrorInputs: [],
      stringError: '',
      clientId: false,
      clientIdRequest: false,
    }
  },
  computed: {
    formattedLastChange() {
      return this.userData ? dayjs(this.userData.lastchange).format('DD/MM/YYYY') : ''
    },
  },
  watch: {
    userData() {
      this.nameInput = this.userData.name
      this.surnameInput = this.userData.surname
      this.emailInput = this.userData.email
      this.formLang = this.userData.language
      this.formSex = this.userData.gender
      this.clientId = this.userData.clientId ? this.userData.clientId : false
      this.clientIdRequest = this.userData.clientIdRequest ? this.userData.clientIdRequest : false
    },
    nameInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('name') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('name'), 1)
      }
    },
    surnameInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('surname') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('surname'), 1)
      }
    },
    emailInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('email') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('email'), 1)
      }
    },
    passInput() {
      //check if has error before
      if (this.arrayErrorInputs.indexOf('password') !== -1) {
        this.arrayErrorInputs.splice(this.arrayErrorInputs.indexOf('password'), 1)
      }
    },
  },
  methods: {
    modalClose() {
      this.$modal.hide('modal-drop-out')
    },
    toggleEditMode() {
      this.editMode = !this.editMode
    },
    dropOutConfirm() {
      this.$modal.show('modal-drop-out')
    },
    requestClientId() {
      requestClientID().then(resp => {
        if (resp.code === 200) {
          this.clientIdRequest = true
        }
      })
    },
    saveEdit() {
      if (this.nameInput === '' && this.arrayErrorInputs.indexOf('name') === -1) {
        this.arrayErrorInputs.push('name')
      }
      if (this.surnameInput === '' && this.arrayErrorInputs.indexOf('surname') === -1) {
        this.arrayErrorInputs.push('surname')
      }
      let reg = /[^\s]*@[a-z0-9.-]*/i
      if (
        (this.emailInput === '' || !reg.test(this.emailInput)) &&
        this.arrayErrorInputs.indexOf('email') === -1
      ) {
        this.arrayErrorInputs.push('email')
      }

      //check del password
      let regex1 = /[A-Z]/
      let regex2 = /[a-z]/
      let regex3 = /\d/
      if (
        (this.passInput.length < 8 ||
          !regex1.test(this.passInput) ||
          !regex2.test(this.passInput) ||
          !regex3.test(this.passInput)) &&
        this.arrayErrorInputs.indexOf('password') === -1
      ) {
        this.arrayErrorInputs.push('password')
      }

      if (this.arrayErrorInputs.length === 0) {
        // user.formModification = dayjs(new Date()).format('DD/MM/YYYY')
        setUserData(
          this.nameInput,
          this.surnameInput,
          this.formLang !== 'NS' ? this.formLang : this.userData.language,
          this.formSex,
          this.emailInput,
          this.passInput
        )
          .then(resp => {
            resp
            this.stringError = ''
            this.toggleEditMode()
            setTimeout(() => {
              window.location.reload()
            }, 1)
          })
          .catch(err => {
            this.stringError = err.response.data.error
          })
      }
    },
  },
  asyncComputed: {
    userData() {
      this.clientIdRequest
      return getUserData().then(resp => {
        if (resp.code === 500 || resp.code === 404 || resp.code === 401) {
          this.$store.dispatch('deleteUser').then(() => this.$router.push({ name: 'Cover' }))
        }
        return resp
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.user-dates
  padding-bottom: vw(50px)
  background-color: $very-light-grey

  .error-msg
    m-font-size(15, 20)
    margin-bottom: vw(15px)
    color: $warning
    font-weight: 600

  .top-wrap
    display: flex
    justify-content: space-between
    align-items: center
    padding: vw(30px) 0 vw(20px)
    width: 50%

    h3
      margin-block-start: 0
      margin-block-end: 0
      m-font-size(24, 28)
      font-weight: 400

    .icon-edit
      cursor: pointer
      m-icon("edit-black-fill", 28, black, false)

    .edition-wrapper
      display: flex
      align-items: center
      gap: vw(20px)

      .close-wrapper
        display: flex
        justify-content: center
        align-items: center
        padding: vw(3px)
        border: 1px solid black
        border-radius: 50%
        cursor: pointer

        &:hover
          background-color: $bcn-light-grey

        .icon-close
          m-icon("close", 20, black, false)

      .button-save
        display: flex
        align-items: center
        padding: vw(4px) vw(15px)
        border-radius: 6px
        background-color: black
        color: white
        cursor: pointer

        &:hover
          background-color: $grey-dark

        span
          m-font-size(16, 20)
          font-weight: 400

  .info-wrapper
    padding: vw(15px)
    width: 50%
    border-radius: 4px
    background-color: white
    box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)
    
    .mobile &
      width: 100%

    table
      width: 100%
      border-collapse: collapse

    .op-wrap
      height: vw(60px)
      border-bottom: 1px solid $light-grey

    .op-extend-wrap
      height: vw(60px)

    .op-extention-wrap
      height: vw(40px)
      border-bottom: 1px solid $light-grey

    .op-ans
      m-font-size(18, 26)
      width: 65%
      color: black
      font-weight: 600
      
      .state-pending
        m-font-size(15, 20)
        font-weight: 400
        color: $grey-dark

      .register-input
        m-font-size(16, 20)
        position: relative
        padding: 0
        padding-right: vw(10px)
        padding-left: vw(10px)
        width: 100%
        height: vw(44px)
        outline: none
        border: 1px solid $grey-grey
        border-radius: 4px
        background-color: $light-grey
        color: #000
        font-weight: 400

        &.error
          border: 2px solid $warning

      .register-select
        m-font-size(16, 20)
        position: relative
        padding: 0
        padding-right: vw(10px)
        padding-left: vw(10px)
        width: 100%
        height: vw(48px)
        outline: none
        border: 1px solid $grey-grey
        border-radius: 4px
        background-color: $light-grey
        color: #000
        font-weight: 400

    .op-type
      m-font-size(14, 18)
      width: 35%
      color: $grey
      font-weight: 400

    .op-mod
      m-font-size(14, 18)
      color: black
      font-weight: 400

  .button-drop-out
    margin-top: vw(30px)
    padding: vw(5px) vw(15px)
    width: fit-content
    border: 1px solid $grey-grey
    border-radius: 3px
    cursor: pointer

    &:hover
      background-color: $grey-dark

      span
        color: white

    span
      m-font-size(14, 20)
      display: flex
      align-items: center
      color: $grey-dark
      
    &.not-margin
      margin-top: vw(0px)
</style>